import * as React from 'react'
import {NullAsDefault} from "../../views/Shared";

class ErrorBoundary extends React.PureComponent {
  state = { error: null }
  _isMounted = false;
  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidCatch = (error, errorInfo) => {
    console.error({ error, errorInfo })
    // window.Raven && window.Raven.captureException(error, { extra: errorInfo });
    if (this._isMounted) {
      this.setState({ error });
    }
  }
  render() {
    const { error } = this.state
    const { fallbackComponent: FallbackComponent = NullAsDefault, children } = this.props

    if (error && !!FallbackComponent) {
      return <FallbackComponent />;
    }

    if (error) {
      return null;
    }

    return children
  }
}

export default ErrorBoundary
